import React, { useState } from 'react'
import { useIntl } from 'react-intl';
import cx from 'classnames';

import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import CommonTable from '../CommonTable/CommonTable';
import CurrencyConverter from '../CurrencyConverter/CurrencyConverter';
import TableAction from '../CommonTable/TableAction';
import CustomPagination from '../CustomPagination/CustomPagination';
import Link from '../Link/Link';
import { getAllPurchaseUsers } from '../../lib/graphql/servicePlans';
import { withQuery } from '../../hoc/withGraphql';
import debounce from '../../helpers/debounce';
import cs from '../../components/commonStyle.css';
import messages from '../../locale/jsonMessages';
import { getPurchaseServicePlanValue } from '../../helpers/GetDynamicItemName/dynamicHomeValue';



const UserServicePlanManagement = (props) => {


    const { data: { getAllPurchaseUsers = {}, refetch, loading } } = props;

    const { formatMessage, locale } = useIntl();
    const [currentPage, setCurrentPage] = useState(1);
    const [searchKey, setSearchKey] = useState("");
    const [userType, setUserType] = useState('');
    const [activeStatus, setActiveStatus] = useState('');

    const setStateVariable = (variables) => {
        if (variables.currentPage !== undefined) {
            setCurrentPage(variables.currentPage);
        }
        setSearchKey(variables?.searchKey);
        setUserType(variables?.userType);
        setActiveStatus(variables?.activeStatus)
    };

    const handleSearchChange = debounce((value) => {
        const variables = { currentPage: 1, searchKey: value, userType, activeStatus };
        setStateVariable(variables);
        refetch(variables);
    }, 250);

    const userTypeFilter = () => {
        return [
            { value: "", label: formatMessage(messages.planTypeLabel) },
            { value: "renter", label: formatMessage(messages.guest) },
            { value: "owner", label: formatMessage(messages.host) }
        ]
    }

    const tableStatusFilter = () => {
        return [
            { value: "", label: formatMessage(messages.allStatusLabel) },
            { value: "active", label: formatMessage(messages.activeLabel) },
            { value: "expired", label: formatMessage(messages.expiredPlanLabel) },
            { value: "cancelled", label: formatMessage(messages.cancelledServicePlanLabel) }
        ]
    }

    const handleDropDown = (e) => {
        const variables = { userType: e, currentPage: 1, searchKey, activeStatus };
        setStateVariable(variables);
        refetch(variables)
    };

    const handleStatusDropDown = (e) => {
        const variables = { activeStatus: e.target.value, currentPage: 1, searchKey, userType };
        setStateVariable(variables);
        refetch(variables)
    };

    const paginationData = (newPage) => {
        const variables = { currentPage: newPage, searchKey, userType, activeStatus };
        setStateVariable(variables);
        refetch(variables);
    };

    const thead = () => [
        { data: formatMessage(messages.idLabel) },
        { data: formatMessage(messages.serviceUserLabel) },
        { data: formatMessage(messages.planPurchased) },
        { data: formatMessage(messages.currentPlanLabel) },
        { data: formatMessage(messages.priceLabel) },
        { data: formatMessage(messages.duration) },
        { data: formatMessage(messages.status) }
    ];

    const tbody = () =>
        getAllPurchaseUsers?.results?.map((value, key) => {
            const planDetails = JSON.parse(value?.dynamicServicePlanDetails || '[]');
            const matchPlan = getPurchaseServicePlanValue(planDetails, locale)
            const planName = matchPlan?.planName ? matchPlan?.planName : value?.servicePlanName;
            return {
                id: key,
                data: [
                    { data: value?.id },
                    {
                        data: <div className={cx(cs.displayFlex, cs.alignCenter, cs.spaceBetween)}>
                            <Link to={`/siteadmin/profileView/${value?.PurchaserData?.profileId}`} className={cs.siteLinkColor}>
                                {value?.PurchaserData?.firstName}
                            </Link>
                            <TableAction
                                showView={true}
                                link={`/siteadmin/user-purchased-plans/view/${value?.userId}`}
                            />
                        </div>
                    },
                    { data: <div>{value?.isPlanType ? (`${formatMessage(messages.guest)} , ${formatMessage(messages.host)}`) : (value?.userType === 'renter' ? formatMessage(messages.guest) : formatMessage(messages.host))}</div> },
                    { data: planName },
                    {
                        data: (<CurrencyConverter
                            amount={value?.price}
                            from={value?.currency} />)
                    },
                    { data: (<div>{value?.duration} {value?.duration == 1 ? formatMessage(messages.month) : formatMessage(messages.monthsLabel)} </div>) },
                    {
                        data: value?.servicePlanStatus == 'active' ? <span className='verifiedText'>{formatMessage(messages.activeLabel)}</span> :
                            (value?.servicePlanStatus == 'cancelled' ? <span className='cancelStatusText'>{formatMessage(messages.cancelledServicePlanLabel)}</span> :
                                formatMessage(messages.expiredPlanLabel))
                    },
                ]
            }
        });

    return (
        <div>
            {
                !loading && <CommonTable
                    thead={thead}
                    tbody={tbody}
                    filterOption={(tableStatusFilter())}
                    handleFilter={(e) => handleStatusDropDown(e)}
                    title={formatMessage(messages.servicePlanUsers)}
                    isSearch
                    onSearch={(e) => handleSearchChange(e?.target?.value)}
                    isLink
                    userTypeFilter={userTypeFilter()}
                    handleUserChange={(e) => handleDropDown(e)}
                />
            }
            {
                !loading && getAllPurchaseUsers?.results?.length > 0
                && <div>
                    <CustomPagination
                        total={getAllPurchaseUsers?.count}
                        currentPage={currentPage}
                        defaultCurrent={1}
                        defaultPageSize={10}
                        change={paginationData}
                        paginationLabel={formatMessage(messages.servicePlanUsers)}
                    />
                </div>
            }
        </div>
    )
}


export default compose(
    withStyles(cs),
    withQuery(
        getAllPurchaseUsers,
        {
            options: (props) => ({
                variables: {
                    currentPage: props.currentPage,
                    searchList: props.searchKey,
                    userType: props.userType,
                    activeStatus: props.activeStatus
                },
                fetchPolicy: 'network-only',
                ssr: false
            })
        }
    )
)(UserServicePlanManagement);
